export const segmentPopoverClearance = {
  top: 165 + 30 + 10, // height of segment popover + map controls + offset
  left: 150, // half-width of segment popover
  right: 150,
  bottom: 30
}
